var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 46C35.7025 46 46 35.7025 46 23C46 10.2975 35.7025 0 23 0C10.2975 0 0 10.2975 0 23C0 35.7025 10.2975 46 23 46Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9998 23H45.9998C45.9998 20.9241 45.7231 18.913 45.2074 17H21.9998V23Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9998 11H42.624C41.216 8.70255 39.4158 6.67181 37.3169 5H21.9998V11Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9998 46C28.4128 46 33.388 44.1291 37.3169 41H8.68262C12.6115 44.1291 17.5868 46 22.9998 46Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.37594 35H42.6244C43.7547 33.1556 44.6313 31.1395 45.2078 29H0.79248C1.36901 31.1395 2.24561 33.1556 3.37594 35V35Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.654 3.59177H12.75L10.8004 5.00816L11.5451 7.29998L9.59558 5.8836L7.64606 7.29998L8.28934 5.3201C6.57279 6.74996 5.06827 8.42519 3.82842 10.2918H4.5L3.25899 11.1934C3.06565 11.5159 2.88021 11.8436 2.7025 12.1761L3.29511 14L2.18949 13.1967C1.91466 13.779 1.66328 14.3744 1.43732 14.9822L2.09021 16.9918H4.5L2.55039 18.4082L3.29511 20.7L1.34559 19.2836L0.177801 20.1321C0.0609141 21.0717 0 22.0287 0 23H23C23 10.2975 23 8.80002 23 0C18.4564 0 14.2209 1.31801 10.654 3.59177V3.59177ZM11.5451 20.7L9.59558 19.2836L7.64606 20.7L8.39078 18.4082L6.44117 16.9918H8.85096L9.59558 14.7L10.3402 16.9918H12.75L10.8004 18.4082L11.5451 20.7ZM10.8004 11.7082L11.5451 14L9.59558 12.5836L7.64606 14L8.39078 11.7082L6.44117 10.2918H8.85096L9.59558 7.99996L10.3402 10.2918H12.75L10.8004 11.7082ZM19.7951 20.7L17.8456 19.2836L15.8961 20.7L16.6408 18.4082L14.6912 16.9918H17.1009L17.8456 14.7L18.5902 16.9918H21L19.0504 18.4082L19.7951 20.7ZM19.0504 11.7082L19.7951 14L17.8456 12.5836L15.8961 14L16.6408 11.7082L14.6912 10.2918H17.1009L17.8456 7.99996L18.5902 10.2918H21L19.0504 11.7082ZM19.0504 5.00816L19.7951 7.29998L17.8456 5.8836L15.8961 7.29998L16.6408 5.00816L14.6912 3.59177H17.1009L17.8456 1.29995L18.5902 3.59177H21L19.0504 5.00816Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_36"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.d62a973eeca870ed3f9ba8bc18865f53.svg";
export { ForwardRef as ReactComponent };